export const BACKEND_URL =
  "https://op736le3y3.execute-api.us-east-1.amazonaws.com/prod";
export const MAX_MESSAGE_LENGTH = 5000;
